import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { add, cloneDeep } from 'lodash'

import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MainService } from '../services/main.service';
import { MatStepper } from '@angular/material/stepper';
import { RequestService } from '../services/request.service';
import Swal from 'sweetalert2';

declare var $: any;
interface Term {
  termName: string;
  termType: string;
  properties: any;
}

interface Annotation {
  type: string;
  value: string;
}

interface Schema {
  annotations: Annotation[];
  termProperties: any[];
  annotationsObj: {}
}

@Component({
  selector: 'app-business-term',
  templateUrl: './business-term.component.html',
  styleUrls: ['./business-term.component.css']
})
export class BusinessTermComponent implements OnInit {
  requiredStepForm: FormGroup;
  dataObj = {}
  datatype = [
    'STRING', 'INTEGER', 'DECIMAL', 'JSON', 'DATE',
    'TIME', 'DATETIME', 'BOOLEAN'
  ];
  codevaluetcd = [
    { code: 'SV', value: 'Single Code Value' },
    { code: 'MV', value: 'Multi Code Value' },


  ]
  roundtypearr = [
    { code: 'HALF_UP', value: 'HALF UP' },
    { code: 'HALF_DOWN', value: 'HALF DOWN' },
    { code: 'HALF_TO_ZERO', value: 'HALF TO ZERO' },
    { code: 'HALF_AWAY_FROM_ZERO', value: 'HALF AWAY FROM ZERO' }
  ]
  boolarr = [true, false]
  yesnoarr = [{
    code: true, value: 'Yes'
  },
  {
    code: false, value: 'No'
  }]
  classificationflag = 'NO'


  constructor(private fb: FormBuilder, public request: RequestService, public main: MainService, private location: Location, private route: ActivatedRoute) { }
  form: FormGroup;
  checksform: FormGroup
  rrvconfig: any = {}
  mode: any
  diid;
  async ngOnInit() {

    let obj: any = this.route.snapshot.queryParamMap.get('id');
    //console.log(obj);
    let a = window.atob(obj)
    let b = JSON.parse(a);
    this.rrvconfig = b
    console.log(this.rrvconfig);
    this.mode = this.rrvconfig['mode']
    this.dataObj = this.request.trObj
    await this.intializeform()
    this.schemaForm = this.fb.group({
      schemaComposition: [''],
      schemaDefinitions: this.fb.array([])
    });
    await this.getAllTerms()
    await this.getcharsetTcd()
    await this.getcollating_seqTcd()
    this.form = this.fb.group({
      expressions: this.fb.array([this.createExpression()])
    });
    this.checksform = this.fb.group({
      validations: this.fb.array([])
    });
    if (this.rrvconfig['mode'] == 'update' || this.rrvconfig['mode'] == 'view') {
      //  await this.intializeform()
      this.diid = this.rrvconfig['formData']?.di_id
      console.log(this.rrvconfig['formData']);
      if (this.rrvconfig['mode'] == 'view') {
        this.requiredStepForm.disable();
      }

      await this.fillformwithdata(this.rrvconfig['formData'])
    }
  }
  getInputType(): string {
    const dataType = this.requiredStepForm.get('dt_tcd').value;
    switch (dataType) {
      case 'STRING':
      case 'JSON':
        return 'text';
      case 'INTEGER':
      case 'DECIMAL':
        return 'number';
      case 'DATE':
        return 'date';
      case 'TIME':
        return 'time';
      case 'DATETIME':
        return 'datetime-local';
      case 'BOOLEAN':
        return 'checkbox';

      default:
        return 'text';
    }
  }

  async intializeform() {
    this.requiredStepForm = this.fb.group({
      di_tech_nm: ['', Validators.required],
      di_bus_nm: ['', Validators.required],
      di_cd: [],
      di_desc: [],
      di_tcd: ['TR'],
      dt_tcd: [],
      hasClassifications: [false],
      hasHierarchy: [false],
      di_tcd_json: this.fb.group({
        pattern: [],
        maxLength: [20],
        precision: [10],
        minLength: [0],
        nullable: [true],
        signed: [false],
        zerofilled: [],
        scale: [2],
        exact: [],
        rounding_method: [],
        sec_fraction: [],


        av_tcd: [],
        comment: [],
        charset: ['utf8'],
        collating_seq: ['utf8_general_ci'],
        surrogate: [false]


      })

      // charset: ['utf8'],
      // collating_seq: ['utf8_general_ci'],
      // comment: []


    });
  }
  originalClArr = [];
  updateObj: any = {}
  async fillformwithdata(data) {

    const formData: any = data;
    this.updateObj = data;

    this.requiredStepForm.patchValue({
      di_tech_nm: formData.di_tech_nm,
      di_bus_nm: formData.di_bus_nm,
      di_cd: formData.di_cd,
      di_desc: formData.di_desc,
      di_tcd: formData.di_tcd || 'TR',
      dt_tcd: formData.di_tcd_json?.data_type?.dt_tcd,
      hasClassifications: !!formData.di_tcd_json?.cl_type,
      hasHierarchy: !!formData.di_tcd_json?.cl_type?.hier_init,

      di_tcd_json: {
        pattern: formData.di_tcd_json?.data_type?.dt_tcd_json?.pattern,
        maxLength: formData.di_tcd_json?.data_type?.dt_tcd_json?.max_len,
        precision: formData.di_tcd_json?.data_type?.dt_tcd_json?.precision,
        minLength: formData.di_tcd_json?.data_type?.dt_tcd_json?.min_len,
        nullable: formData.di_tcd_json?.nullable,
        signed: formData.di_tcd_json?.data_type?.dt_tcd_json?.signed,
        zerofilled: formData.di_tcd_json?.data_type?.dt_tcd_json?.zerofilled,
        scale: formData.di_tcd_json?.data_type?.dt_tcd_json?.scale,
        exact: formData.di_tcd_json?.data_type?.dt_tcd_json?.exact,
        rounding_method: formData.di_tcd_json?.data_type?.dt_tcd_json?.rounding_method,
        sec_fraction: formData.di_tcd_json?.data_type?.dt_tcd_json?.sec_fraction,
        av_tcd: formData.di_tcd_json?.cl_type?.av_tcd,
        comment: formData.di_tcd_json?.comment,
        charset: formData.di_tcd_json?.charset,
        collating_seq: formData.di_tcd_json?.collating_seq,
        surrogate: formData.di_tcd_json?.surrogate
      }
    });
    if (Array.isArray(formData.di_tcd_json.checks)) {
      this.checks = formData.di_tcd_json.checks;
      this.populateChecksForm(this.checks);
    }
    if (formData.di_tcd_json?.default) {
      this.default = formData.di_tcd_json.default;
      this.form = this.fb.group({
        expressions: this.fb.array([])
      });
      const expressions = this.form.get('expressions') as FormArray;

      expressions.push(this.createValidationFormGroup(this.default))
      //console.log(expressions);

    }
    if (formData.di_tcd_json?.cl_type?.av_tcd == 'SV') {
      // let av_initarr = formData.di_tcd_json?.cl_type?.av_init
      // av_initarr.forEach(async (ele) => {
      //      let obj={

      //      }
      //      obj['cl_cd']=ele[0]
      //      obj['cl_val']=ele[1]
      //      this.clarr.push(obj)
      // })
      //   await this.getClassifications()

    }
    if (formData.di_tcd_json?.data_type?.dt_tcd == 'JSON') {
      await this.populateFormFromJSON(formData.di_tcd_json?.data_type?.dt_tcd_json?.schema, this.schemas)

    }
    if (formData.di_tcd_json?.cl_type?.av_tcd == 'MV') {
      if (formData.di_tcd_json?.cl_type?.mv_schema) {
        await this.populateFormFromJSON(formData.di_tcd_json?.cl_type?.mv_schema, this.schemasmv)

      }

    }

    // if(formData.di_tcd_json?.data_type?.dt_tcd=='JSON'){

    // }
  }
  async populateFormFromJSON(schemaJson: any, schemas: any) {
    if (schemaJson.anyOf || schemaJson.oneOf || schemaJson.allOf) {
      this.schemacompostiontype = schemaJson.anyOf
        ? 'anyOf'
        : schemaJson.oneOf
          ? 'oneOf'
          : 'allOf';

      const compositionArray = schemaJson.anyOf || schemaJson.oneOf || schemaJson.allOf;
      compositionArray.forEach(async (subSchema: any, index: number) => {
        await this.processSubSchema(subSchema, schemas, index);
      });
    } else {
      this.schemacompostiontype = 'noComposition';
      this.processSubSchema(schemaJson, schemas, 0);
    }

    console.log(schemas);
  }

  async processSubSchema(subSchema: any, schemas: any, schemaIndex?: number) {
    if (!schemas[schemaIndex]) {
      schemas[schemaIndex] = { termProperties: [], annotations: [], annotationsObj: {} };
    }

    const schemaForm = schemas[schemaIndex];

    if (subSchema.properties) {
      for (const key of Object.keys(subSchema.properties)) {
        let property = subSchema.properties[key];

        const convertedTerm = {
          tech_nm: key,
          title: property.title || key,
          description: property.description || '',
          properties: property,
          annotations: []
        };

        if (subSchema.required && subSchema.required.includes(key)) {
          convertedTerm['properties']['required'] = true;
        } else {
          convertedTerm['properties']['required'] = false;
        }

        schemaForm.termProperties.push(convertedTerm);
      }
    }

    const schemaAnnotations = [];
    if (subSchema.title) {
      schemaAnnotations.push({ type: 'title', value: subSchema.title });
    }
    if (subSchema.description) {
      schemaAnnotations.push({ type: 'description', value: subSchema.description });
    }

    schemaForm.annotations = schemaAnnotations;
  }




  populateChecksForm(checks: any[]) {
    const validations = this.checksform.get('validations') as FormArray;
    checks.forEach(check => {
      validations.push(this.createValidationFormGroup(check));
    });
  }
  async getClassifications() {

    this.clarr = []
    this.originalClArr = []
    let where: any = {
      "and": [


        {
          "di_id": {
            "=": this.diid
          }
        }

      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      console.log(resp);


      if (!resp.error) {
        this.clarr = resp['data'][0]['cl']
        this.originalClArr = JSON.parse(JSON.stringify(this.clarr));





      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }

  createValidationFormGroup(check: any): FormGroup {
    if ('name' in check) {
      return this.fb.group({
        type: 'Variable',
        name: check.name
      });
    }
    else if ('const' in check) {
      if (typeof check.const === 'object' && check.const !== null) {

        return this.fb.group({
          type: 'Literal',
          const:
            JSON.stringify(check.const, null, 2)
        });
      } else {

        return this.fb.group({
          type: 'Literal',
          const: check.const
        });
      }
    }
    else if ('operator' in check) {
      return this.fb.group({
        type: 'Expression',
        operator: check.operator,
        operands: this.fb.array(check.operands.map((operand: any) => this.createValidationFormGroup(operand)))
      });
    } else {
      return this.fb.group({});
    }
  }
  default: any = {}
  literaltcdarr = ['Literal', 'Variable', 'Expression']
  cust_attr_arr = ['']
  charset = []
  async getcharsetTcd() {
    this.charset = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "charset"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.charset = resp['data'][0]['cl']





      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }
  collating_seq = []
  async getcollating_seqTcd() {
    this.collating_seq = []
    let where: any = {
      "and": [


        {
          "di_tech_nm": {
            "=": "collating_seq"
          }
        },
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,
      "include": {
        "all": true
      }

    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.collating_seq = resp['data'][0]['cl']





      } else {

        Swal.fire('Error!', 'Failed to get classifications.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting classifications:', error);
      Swal.fire('Error!', 'Failed to get classifications.', 'error');
    }
  }

  ///////////////////////////////////////////////schema def//////////////////////
  schemaForm!: FormGroup;
  schemasmv: Schema[] = [
    {
      annotations: [],
      termProperties: [],
      annotationsObj: {}
    }
  ];
  schemas: Schema[] = [{
    annotations: [],
    termProperties: [],
    annotationsObj: {}
  }
  ];
  schemacompostiontype: any | undefined;
  schemaCompositionOptions = [
    { value: 'oneOf', label: 'OneOf' },
    { value: 'anyOf', label: 'AnyOf' },
    { value: 'allOf', label: 'AllOf' },
    { value: 'noComposition', label: 'No Composition' }
  ];
  annotationsarr = ['title', 'description']

  annotations: Annotation[] = [];


  termProperties: any[] = [];

  addSchema() {
    this.schemas.push({ annotations: [], termProperties: [], annotationsObj: {} });
  }
  deleteschema(i) {
    this.schemas.splice(i, 1)
  }
  onAddAnnotation(schemaIndex: number) {
    this.schemas[schemaIndex].annotations.push({ type: '', value: '' });
  }
  onDeleteAnnotation(schemaIndex: number, annotationIndex: number) {
    this.schemas[schemaIndex].annotations.splice(annotationIndex, 1);
  }
  async submitAnnotations() {
    // //console.log('Annotations submitted:', this.schemas[schemaIndex].annotations);

    this.schemas.forEach((item, index) => {
      let schemaannotationObj: any = {}
      item.annotations.forEach((item1) => {
        schemaannotationObj[item1.type] = item1.value
      })
      item.annotationsObj = schemaannotationObj

    })

    //this.schemas[schemaIndex].annotationsObj=schemaannotationObj

    //console.log(this.schemas);


  }
  async addTermToProperties(selectedTerm: Term, schemaIndex: number) {
    // selectedTerm.properties.required=false;
    let convertedTerm = await this.request.processTerm(selectedTerm)

    let termind = cloneDeep(convertedTerm)

    this.schemas[schemaIndex].termProperties.push(termind);
    //console.log(this.schemas[schemaIndex].termProperties);


  }
  removeTerm(schemaIndex: number, termIndex: number) {
    this.schemas[schemaIndex].termProperties.splice(termIndex, 1)
  }
  generateSchema(terms: any, schemaannotationObj: any) {
    const schema: any = {
      // $schema: 'http://json-schema.org/draft-07/schema#',
      type: 'object',
      properties: {},
      required: []
    };
    for (let key in schemaannotationObj) {
      schema[key] = schemaannotationObj[key]
    }

    terms.forEach((term: any) => {
      const propertySchema = this.generatePropertySchema(term.properties);
      //console.log(term);

      if (term.properties.type == 'object') {
        schema.properties[term.tech_nm] = term.properties.properties
          ;
      }
      else {
        schema.properties[term.tech_nm] = propertySchema.property;
      }

      if (propertySchema.required) {
        schema.required.push(term.tech_nm);
      }
    });

    //console.log(JSON.stringify(schema, null, 2));
    return schema;
  }

  generatePropertySchema(properties: any): { property: any; required: boolean } {
    let property: any;
    let required: boolean = false;

    if (properties.type === 'object') {
      property = properties;
    }
    else {
      property = {
        type: properties.type
      };
      for (let key in properties) {
        if (key != 'required')
          property[key] = properties[key]
        else
          required = properties.required || false

      }
    }
    required = properties.required || false;

    return { property, required };
  }
  validateObj: any = {}
  async generateSchemapre() {

    await this.submitAnnotations()
    this.validateObj = {}
    let validationarr: any = []
    this.schemas.forEach((item, index) => {

      //console.log(item, 'item')
      validationarr[index] = this.generateSchema(item.termProperties, item.annotationsObj)
    })

    if (this.schemas.length > 1) {
      this.validateObj[this.schemacompostiontype] = validationarr
    }
    else {
      this.validateObj = validationarr[0]
    }
    //console.log(JSON.stringify(this.validateObj, null, 2))
    document.getElementById('json-content')!.textContent = ''
    document.getElementById('json-content')!.textContent = `validation object : ${JSON.stringify(this.validateObj, null, 2)}`;
  }


  addSchemamv() {
    this.schemasmv.push({ annotations: [], termProperties: [], annotationsObj: {} });
  }
  onAddAnnotationmv(schemaIndex: number) {
    //console.log(schemaIndex);

    this.schemasmv[schemaIndex].annotations.push({ type: '', value: '' });
  }


  onDeleteAnnotationmv(schemaIndex: number, annotationIndex: number) {
    this.schemasmv[schemaIndex].annotations.splice(annotationIndex, 1);
  }


  async submitAnnotationsmv() {
    // //console.log('Annotations submitted:', this.schemas[schemaIndex].annotations);

    this.schemasmv.forEach((item, index) => {
      let schemaannotationObj: any = {}
      item.annotations.forEach((item1) => {
        schemaannotationObj[item1.type] = item1.value
      })
      item.annotationsObj = schemaannotationObj

    })

    //this.schemas[schemaIndex].annotationsObj=schemaannotationObj

    //console.log(this.schemasmv);


  }


  async addTermToPropertiesmv(selectedTerm: Term, schemaIndex: number) {
    // selectedTerm.properties.required=false;
    let convertedTerm = await this.request.processTerm(selectedTerm)

    let termind = cloneDeep(convertedTerm)

    this.schemasmv[schemaIndex].termProperties.push(termind);
    //console.log(this.schemasmv[schemaIndex].termProperties);


  }

  removeTermmv(schemaIndex: number, termIndex: number) {
    this.schemasmv[schemaIndex].termProperties.splice(termIndex, 1)
  }



  onCheckboxChange(i: any, k: any) {
    // term.required = !term.required;
    this.schemas[i].termProperties[k].properties.required = !this.schemas[i].termProperties[k].properties.required
  }
  onCheckboxChangemv(i: any, k: any) {
    // term.required = !term.required;
    this.schemasmv[i].termProperties[k].properties.required = !this.schemasmv[i].termProperties[k].properties.required
  }

  showProperties(property: any) {
    // Logic to show properties when the button is clicked
    //$('#termpropertiesview').modal('show')
    $("#termpropertiesview").modal("show");
  }




  validateObjmv: any = {}
  async generateSchemamv() {

    await this.submitAnnotationsmv()
    this.validateObjmv = {}
    let validationarr: any = []
    this.schemasmv.forEach((item, index) => {

      //console.log(item, 'item')
      validationarr[index] = this.generateSchema(item.termProperties, item.annotationsObj)
    })

    if (this.schemasmv.length > 1) {
      this.validateObjmv[this.schemacompostiontype] = validationarr
    }
    else {
      this.validateObjmv = validationarr[0]
    }
    //console.log(JSON.stringify(this.validateObjmv, null, 2))

  }

  closeModal() {
    $('#termpropertiesview').modal('hide')
  }
  compositionchange(value: any) {
    this.schemas = [{
      annotations: [],
      termProperties: [],
      annotationsObj: {}
    }
    ];
    document.getElementById('json-content')!.textContent = ''
  }
  termarr = []
  async getAllTerms() {
    this.termarr = []
    let where: any = {
      "and": [
        {
          "di_tcd": {
            "=": "TR"
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      filter: where,


    };
    try {

      const resp = await this.main.getListData(req_obj);
      //console.log(resp);


      if (!resp.error) {
        this.termarr = resp['data']
        //  this.clArr.push({ cl_cd: "APP", cl_val: "Application" })

        // Swal.fire('Deleted!', 'Node has been deleted.', 'success');




      } else {

        Swal.fire('Error!', 'Failed to get terms.', 'error');
      }
    } catch (error) {

      //console.error('Error while getting terms:', error);
      Swal.fire('Error!', 'Failed to get terms.', 'error');
    }
  }

  /////////////////////hooks///////////
  rows = []




  valueOptions = ['Process 1', 'Process 2', 'Process 3'];
  /////////////default///////////////////

  operands = []


  removeOperand(index: number) {
    this.operands.splice(index, 1);
  }
  onOperandTypeChange(operand, index) {
    if (operand.type === 'literal') {
      operand.const = '';
      delete operand.name;
      delete operand.data_type;
    } else if (operand.type === 'variable') {
      operand.name = '';
      operand.data_type = 'STRING';
      delete operand.const;
    }
  }
  operators: any = [
    { code: "json_valid", value: "json_valid" },
    { code: "json_value", value: "json_value" },
    { code: "json_query", value: "json_query" },
    { code: "cur_tm", value: "cur_tm" },
    { code: "cur_dt", value: "cur_dt" },
    { code: "cur_ts", value: "cur_ts" },
    { code: "cur_usr", value: "cur_usr" },
    { code: "$concat", value: "$concat" },
    { code: "$substr", value: "$substr" },
    { code: "$lower", value: "$lower" },
    { code: "$upper", value: "$upper" },
    { code: "$hex", value: "$hex" },
    { code: "$unhex", value: "$unhex" },
    { code: "$md5", value: "$md5" },
    { code: "$+", value: "$+" },
    { code: "$-", value: "$-" },
    { code: "$*", value: "$*" },
    { code: "$/", value: "$/" },
    { code: "$%", value: "$%" },
    { code: "is", value: "is" },
    { code: "not", value: "not" },
    { code: "isEmail", value: "isEmail" },
    { code: "isUrl", value: "isUrl" },
    { code: "isIP", value: "isIP" },
    { code: "isIPv4", value: "isIPv4" },
    { code: "isIPv6", value: "isIPv6" },
    { code: "isAlpha", value: "isAlpha" },
    { code: "isAlphanumeric", value: "isAlphanumeric" },
    { code: "isNumeric", value: "isNumeric" },
    { code: "isInt", value: "isInt" },
    { code: "isFloat", value: "isFloat" },
    { code: "isDecimal", value: "isDecimal" },
    { code: "isLowercase", value: "isLowercase" },
    { code: "isUppercase", value: "isUppercase" },
    { code: "notNull", value: "notNull" },
    { code: "isNull", value: "isNull" },
    { code: "notEmpty", value: "notEmpty" },
    { code: "equals", value: "equals" },
    { code: "contains", value: "contains" },
    { code: "notIn", value: "notIn" },
    { code: "isIn", value: "isIn" },
    { code: "notContains", value: "notContains" },
    { code: "len", value: "len" },
    { code: "isUUID", value: "isUUID" },
    { code: "isDate", value: "isDate" },
    { code: "isAfter", value: "isAfter" },
    { code: "isBefore", value: "isBefore" },
    { code: "max", value: "max" },
    { code: "min", value: "min" },
    { code: "isCreditCard", value: "isCreditCard" },
    { code: "isInAV", value: "isInAV" },
    { code: "isJsonValidAgainstSchema", value: "isJsonValidAgainstSchema" },
    { code: "$and", value: "$and" },
    { code: "$or", value: "$or" },
    { code: "$not", value: "$not" },
    { code: "$if", value: "$if" },
    { code: "$eq", value: "$eq" },
    { code: "$ne", value: "$ne" },
    { code: "$gt", value: "$gt" },
    { code: "$gte", value: "$gte" },
    { code: "$lt", value: "$lt" },
    { code: "$lte", value: "$lte" },
    { code: "$bw", value: "$bw" },
    { code: "$nbw", value: "$nbw" },
    { code: "$in", value: "$in" },
    { code: "$nin", value: "$nin" },
    { code: "$lk", value: "$lk" },
    { code: "$nlk", value: "$nlk" }
  ];
  operatorchecks: any = [
    { code: "is", value: "is" },
    { code: "not", value: "not" },
    { code: "isEmail", value: "isEmail" },
    { code: "isUrl", value: "isUrl" },
    { code: "isIP", value: "isIP" },
    { code: "isIPv4", value: "isIPv4" },
    { code: "isIPv6", value: "isIPv6" },
    { code: "isAlpha", value: "isAlpha" },
    { code: "isAlphanumeric", value: "isAlphanumeric" },
    { code: "isNumeric", value: "isNumeric" },
    { code: "isInt", value: "isInt" },
    { code: "isFloat", value: "isFloat" },
    { code: "isDecimal", value: "isDecimal" },
    { code: "isLowercase", value: "isLowercase" },
    { code: "isUppercase", value: "isUppercase" },
    { code: "notNull", value: "notNull" },
    { code: "isNull", value: "isNull" },
    { code: "notEmpty", value: "notEmpty" },
    { code: "equals", value: "equals" },
    { code: "contains", value: "contains" },
    { code: "notIn", value: "notIn" },
    { code: "isIn", value: "isIn" },
    { code: "notContains", value: "notContains" },
    { code: "len", value: "len" },
    { code: "isUUID", value: "isUUID" },
    { code: "isDate", value: "isDate" },
    { code: "isAfter", value: "isAfter" },
    { code: "isBefore", value: "isBefore" },
    { code: "max", value: "max" },
    { code: "min", value: "min" },
    { code: "isCreditCard", value: "isCreditCard" },
    { code: "isInAV", value: "isInAV" },
    { code: "isJsonValidAgainstSchema", value: "isJsonValidAgainstSchema" },
    { code: "$and", value: "$and" },
    { code: "$or", value: "$or" },
    { code: "$not", value: "$not" },
    { code: "$if", value: "$if" },
    { code: "$eq", value: "$eq" },
    { code: "$ne", value: "$ne" },
    { code: "$gt", value: "$gt" },
    { code: "$gte", value: "$gte" },
    { code: "$lt", value: "$lt" },
    { code: "$lte", value: "$lte" },
    { code: "$bw", value: "$bw" },
    { code: "$nbw", value: "$nbw" },
    { code: "$in", value: "$in" },
    { code: "$nin", value: "$nin" },
    { code: "$lk", value: "$lk" },
    { code: "$nlk", value: "$nlk" }
  ];


  ///////////////////////////////////////
  get expressions(): FormArray {
    return this.form.get('expressions') as FormArray;
  }
  get validations(): FormArray {

    return this.checksform.get('validations') as FormArray;

  }

  createExpression(): FormGroup {
    return this.fb.group({
      type: new FormControl(''),
      operator: new FormControl(''),
      operands: this.fb.array([]),
      const: new FormControl(),
      name: new FormControl('')
    });
  }
  createValidation(): FormGroup {
    return this.fb.group({
      type: new FormControl(''),
      operator: new FormControl(''),
      operands: this.fb.array([]),
      const: new FormControl(''),
      name: new FormControl('')
    });
  }

  addOperand(expressionCtrl: FormGroup) {
    const operands = expressionCtrl.get('operands') as FormArray;
    operands.push(this.createExpression());
  }

  getOperands(control: FormGroup): FormArray {
    return control.get('operands') as FormArray;
  }
  deleteOperand(expressionCtrl: FormGroup, index: number) {
    const operands = expressionCtrl.get('operands') as FormArray;
    operands.removeAt(index);
  }
  addValidation() {
    this.validations.push(this.createValidation());
  }

  removeValidation(index: number) {
    this.validations.removeAt(index);
  }



  async onSubmit() {
    console.log(this.form.value);
    const result = await this.constructFinalObject(this.form.value.expressions[0]);
    //console.log(JSON.stringify(result, null, 2));
    this.default = result
  }
  checks: any = {}
  async onSubmit1() {
    this.checks = []
    //console.log(this.checksform.value);
    // const result = await this.constructFinalObject(this.checksform.value.validations[0]);
    for (const ele of this.checksform.value.validations) {
      let result = await this.constructFinalObject(ele);
      //console.log(result);
      this.checks.push(result);
    }

    // this.checks = result

    //console.log(this.checks);
  }

  async constructFinalObject(expression: any): Promise<any> {
    switch (expression.type) {
      case 'Literal':
        return { const: this.convertValue(expression.const) };
      case 'Variable':
        return { name: expression.name };
      case 'Expression':
        const operands = await Promise.all(expression.operands.map(async (operand: any) => {
          return await this.constructFinalObject(operand);
        }));
        return {
          operator: expression.operator,
          operands: operands
        };
      default:
        return {};
    }
  }
  convertValue(value: any): any {
    const dataType = this.requiredStepForm.get('dt_tcd').value;
    switch (dataType) {
      case 'INTEGER':
      case 'DECIMAL':
        return isNaN(Number(value)) ? value : Number(value);
      case 'BOOLEAN':
        return value ? value : false

      default:
        return value;
    }
  }
  async submit() {

    if (await this.validateForm()) {
      // await this.checkifrecordexistsornot()

    }

  }

  async validateForm(): Promise<boolean> {

    const formGroup = this.requiredStepForm;

    if (formGroup.valid) {
      await this.fillWithDefaults()
      return true;

    } else {

      Object.keys(formGroup.controls).forEach((key: string) => {
        const control = formGroup.get(key);
        control.markAsTouched({ onlySelf: true });
      });
      Swal.fire('Error!', 'Form is Invalid', 'error');

      return false;
    }
  }
  async saveInnerStep(stepper) {
    //console.log(stepper);
    //console.log(stepper);


  }
  async fillWithDefaults() {
    if (!this.requiredStepForm.get('di_cd').value) {
      const techname = this.requiredStepForm.get('di_tech_nm').value;
      this.requiredStepForm.get('di_cd').setValue(`TR-${techname}`);
    }
    if (!this.requiredStepForm.get('dt_tcd').value) {
      this.requiredStepForm.get('dt_tcd').setValue('STRING');
    }
    if (!this.requiredStepForm.get('di_tcd_json.maxLength').value) {
      this.requiredStepForm.get('di_tcd_json.maxLength').setValue(255);
    }


    await this.addfinal()




  }
  async constructditcdjson() {

    const dt_tcd = this.requiredStepForm.get('dt_tcd').value;
    await this.onSubmit()
    await this.onSubmit1()

    if (!dt_tcd) {
      //console.error('dt_tcd value is not present');
      return;
    }
    let isdefault = Object.keys(this.default).length
    //   let ischeck = Object.keys(this.checks).length
    const di_tcd_json: any = {
      data_type: { dt_tcd: dt_tcd },

    };
    const formData = this.requiredStepForm.value;
    if (isdefault) {
      di_tcd_json['default'] = this.default
    }
    if (this.checks.length > 0) {
      di_tcd_json['checks'] = this.checks
    }
    if (formData.di_tcd_json.hasOwnProperty('nullable') && formData.di_tcd_json.nullable !== null) {
      di_tcd_json.nullable = formData.di_tcd_json.nullable;
    }

    if (formData.di_tcd_json.hasOwnProperty('surrogate') && formData.di_tcd_json.surrogate !== null) {
      di_tcd_json.surrogate = formData.di_tcd_json.surrogate;
    }
    if (formData.di_tcd_json.hasOwnProperty('collating_seq') && formData.di_tcd_json.collating_seq !== null && (dt_tcd == 'STRING' || dt_tcd == 'JSON')) {
      di_tcd_json.collating_seq = formData.di_tcd_json.collating_seq;
    }
    if (formData.di_tcd_json.hasOwnProperty('charset') && formData.di_tcd_json.charset !== null && (dt_tcd == 'STRING' || dt_tcd == 'JSON')) {
      di_tcd_json.charset = formData.di_tcd_json.charset;
    }
    if (formData.di_tcd_json.hasOwnProperty('comment') && formData.di_tcd_json.comment !== null) {
      di_tcd_json.comment = formData.di_tcd_json.comment;
    }

    if (this.requiredStepForm.get('hasClassifications').value) {

      di_tcd_json['cl_type'] = {
        av_tcd: formData.di_tcd_json.av_tcd,
        av_init: this.updateObj?.di_tcd_json?.cl_type?.av_init || []
      }


      if (formData.di_tcd_json.av_tcd == 'MV') {
        await this.generateSchemamv()
        di_tcd_json['cl_type']['mv_schema'] = this.validateObjmv

      }
    }
    if (this.requiredStepForm.get('hasHierarchy').value) {
      if (this.mode == 'create') {
        let di_tech_nm = this.requiredStepForm.get('di_tech_nm').value
        let di_bus_nm = this.requiredStepForm.get('di_bus_nm').value

        di_tcd_json['cl_type']['hier_init'] =  []
      }
      else{
        di_tcd_json['cl_type']['hier_init']= this.updateObj?.di_tcd_json?.cl_type?.hier_init || []
      }



    }
    switch (dt_tcd) {
      case 'STRING':
        const string_json: any = {};
        if (formData.di_tcd_json.hasOwnProperty('minLength') && formData.di_tcd_json.minLength !== null) {
          string_json.min_len = formData.di_tcd_json.minLength;
        }
        if (formData.di_tcd_json.hasOwnProperty('maxLength') && formData.di_tcd_json.maxLength !== null) {
          string_json.max_len = formData.di_tcd_json.maxLength;
        }
        if (formData.di_tcd_json.hasOwnProperty('pattern') && formData.di_tcd_json.pattern !== null) {
          string_json.pattern = formData.di_tcd_json.pattern;
        }
        di_tcd_json['data_type']['dt_tcd_json'] = string_json;
        break;

      case 'INTEGER':
        const integer_json: any = {};
        if (formData.di_tcd_json.hasOwnProperty('precision') && formData.di_tcd_json.precision !== null) {
          integer_json.precision = formData.di_tcd_json.precision;
        }
        if (formData.di_tcd_json.hasOwnProperty('signed') && formData.di_tcd_json.signed !== null) {
          integer_json.signed = formData.di_tcd_json.signed;
        }
        if (formData.di_tcd_json.hasOwnProperty('zerofilled') && formData.di_tcd_json.zerofilled !== null) {
          integer_json.zerofilled = formData.di_tcd_json.zerofilled;
        }
        di_tcd_json['data_type']['dt_tcd_json'] = integer_json;
        break;

      case 'DATETIME':
        di_tcd_json['data_type'] = {
          dt_tcd: 'DATETIME'

        };
        if (formData.di_tcd_json.hasOwnProperty('sec_fraction') && formData.di_tcd_json.sec_fraction !== null) {
          if (!di_tcd_json.data_type['dt_tcd_json']) {
            di_tcd_json.data_type['dt_tcd_json'] = {}
          }

          di_tcd_json.data_type['dt_tcd_json']['sec_fraction'] = formData.di_tcd_json.sec_fraction;


        }

        break;
      case 'TIME':
        di_tcd_json['data_type'] = {
          dt_tcd: 'TIME'

        };
        if (formData.di_tcd_json.hasOwnProperty('sec_fraction') && formData.di_tcd_json.sec_fraction !== null) {
          if (!di_tcd_json.data_type['dt_tcd_json']) {
            di_tcd_json.data_type['dt_tcd_json'] = {}
          }

          di_tcd_json.data_type['dt_tcd_json']['sec_fraction'] = formData.di_tcd_json.sec_fraction;


        }

        break;

      case 'DATE':
        di_tcd_json['data_type'] = {
          dt_tcd: 'DATE'
        };

        break;
      case 'BOOLEAN':
        di_tcd_json['data_type'] = {
          dt_tcd: 'BOOLEAN'
        };

        break;

      case 'JSON': await this.generateSchemapre()
        const json_schema = this.validateObj
        di_tcd_json['data_type'] = {
          dt_tcd: 'JSON',
          dt_tcd_json: { schema: json_schema }
        };
        break;

      case 'DECIMAL':
        const decimal_json: any = {};
        if (formData.di_tcd_json.hasOwnProperty('precision') && formData.di_tcd_json.precision !== null) {
          decimal_json.precision = formData.di_tcd_json.precision;
        }
        if (formData.di_tcd_json.hasOwnProperty('scale') && formData.di_tcd_json.scale !== null) {
          decimal_json.scale = formData.di_tcd_json.scale;
        }
        if (formData.di_tcd_json.hasOwnProperty('signed') && formData.di_tcd_json.signed !== null) {
          decimal_json.signed = formData.di_tcd_json.signed;
        }
        if (formData.di_tcd_json.hasOwnProperty('zerofilled') && formData.di_tcd_json.zerofilled !== null) {
          decimal_json.zerofilled = formData.di_tcd_json.zerofilled;
        }
        if (formData.di_tcd_json.hasOwnProperty('rounding_method') && formData.di_tcd_json.rounding_method !== null) {
          decimal_json.rounding_method = formData.di_tcd_json.rounding_method;
        }
        if (formData.di_tcd_json.hasOwnProperty('exact') && formData.di_tcd_json.exact !== null) {
          decimal_json.exact = formData.di_tcd_json.exact;
        }
        di_tcd_json['data_type']['dt_tcd_json'] = decimal_json;

        break;

      default:
        //console.error('Unsupported dt_tcd value:', dt_tcd);
        return;
    }



    //console.log(di_tcd_json);
    return di_tcd_json;


  }
  async addfinal() {
    let addObj = this.requiredStepForm.value
    let di_tcd_json = await this.constructditcdjson()
    //console.log(addObj);

    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    req_obj['columns'] = [
      "di_cd",
      "di_bus_nm",
      "di_tech_nm",
      "di_desc",
      "di_tcd",
      "di_tcd_json"
    ]
    req_obj['values'] = [
      addObj['di_cd'],
      addObj['di_bus_nm'],
      addObj['di_tech_nm'],
      addObj['di_desc'],
      'TR',
      di_tcd_json
    ]
    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {

        Swal.fire('Success!', 'Term added Successfully', 'success');
        //  await this.insertClassifications(resp['data']["di_id"])
        setTimeout(async () => {
          await this.backtolist()
        }, 1000
        )


      } else {

        Swal.fire('Error!', 'Failed to insert Term.', 'error');
      }
    } catch (error) {

      //console.error('Error inserting Term:', error);
      Swal.fire('Error!', 'Failed to insert Term.', 'error');
    }
  }
  async gotoAdditonal(stepper) {

    if (this.requiredStepForm.valid) {

      stepper.next();


    }


  }
  async updateascindi() {
    let addObj = this.requiredStepForm.value
    let di_tcd_json = await this.constructditcdjson()
    //console.log(addObj);
    let req_obj = new Object()
    req_obj['pf_path'] = 'dd'
    req_obj['pf_name'] = 'di'
    req_obj['app_cd'] = 'DD'
    let updateobj = {};
    updateobj['di_cd'] = addObj['di_cd'];
    updateobj['di_bus_nm'] = addObj['di_bus_nm'];
    updateobj['di_tech_nm'] = addObj['di_tech_nm'];
    updateobj['di_desc'] = addObj['di_desc'];
    updateobj['di_tcd'] = 'TR';
    updateobj['di_tcd_json'] = di_tcd_json;
    req_obj['set'] = updateobj

    let where: any = {}

    where['di_id'] = this.diid
    req_obj['where'] = where


    //console.log(req_obj);

    try {
      let resp = await this.main.updateData(req_obj);

      if (!resp['error']) {

        Swal.fire('Success!', 'Term updated Successfully', 'success');

        setTimeout(async () => {
          await this.backtolist()
        }, 2000
        )

      } else {

        Swal.fire('Error!', 'Failed to update Term.', 'error');
      }
    } catch (error) {

      //console.error('Error update Term:', error);
      Swal.fire('Error!', 'Failed to update Term.', 'error');
    }



  }
  async update() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to update the term`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, update it!'
    });


    if (result.isConfirmed) {
      const formGroup = this.requiredStepForm;

      if (formGroup.valid) {
        // await this.fillWithDefaults()

        await this.updateascindi()
        return true;

      } else {

        Object.keys(formGroup.controls).forEach((key: string) => {
          const control = formGroup.get(key);
          control.markAsTouched({ onlySelf: true });
        });
        Swal.fire('Error!', 'Form is Invalid', 'error');

        return false;
      }


    }
    else {
      return false;
    }
  }
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('innerStepper') innerStepper: MatStepper;
  goBackToFirstStepper() {
    this.innerStepper.reset();
    this.stepper.selectedIndex = 0;
  }
  get type() {
    return this.checksform.get('type')?.value;
  }
  async backtolist() {
    this.location.back();
  }
  clarr = []
  async onAddClassification() {
    this.clarr.push({})
  }
  async onDeleteClassification(index) {
    this.clarr.splice(index, 1)
  }
  async getArrayOfClassifications() {

    if (this.clarr.length === 0) {
      let di_tech_nm = this.requiredStepForm.get('di_tech_nm').value
      let di_bus_nm = this.requiredStepForm.get('di_bus_nm').value

      return [[`default_${di_tech_nm}`, `Default ${di_bus_nm}`]];
    }

    const arr = await Promise.all(
      this.clarr.map(async (ele) => {
        return [ele.cl_cd, ele.cl_val];
      })
    );

    return arr;
  }

  async insertClassifications(di_id: any, clarr: any) {
    let classificationReqObj = {
      'pf_path': 'dd',
      'pf_name': 'cl',
      'app_cd': 'DD',
      columns: ["di_id", "cl_cd", "cl_val", "cl_tcd", "cl_tcd_json"],
      values: []
    };

    for (let i = 0; i < clarr.length; i++) {
      const classification = clarr[i];

      classificationReqObj.values.push([
        di_id,
        classification.cl_cd,
        classification.cl_val,
        classification?.cl_tcd || 'AV',
        classification?.cl_tcd_json || { "av_tcd": "SV" }
      ]);
    }

    try {
      let resp = await this.main.addMultiData(classificationReqObj);
      if (!resp['error']) {
        Swal.fire('Success!', 'Classifications inserted successfully.', 'success');
      } else {
        Swal.fire('Error!', 'Failed to insert classifications.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to insert classifications.', 'error');
    }
  }
  async trackChanges() {
    let added = [];
    let updated = [];
    let deleted = [];


    this.clarr.forEach((newCl) => {
      if (!newCl.cl_id) {
        added.push(newCl);
      }
    });


    this.clarr.forEach((newCl) => {
      const originalCl = this.originalClArr.find(cl => cl.cl_id === newCl.cl_id);
      if (originalCl && JSON.stringify(originalCl) !== JSON.stringify(newCl)) {
        updated.push(newCl);
      }
    });


    let deletedClIds = new Set();
    this.originalClArr.forEach((originalCl) => {
      const newCl = this.clarr.find(cl => cl.cl_id === originalCl.cl_id);
      if (!newCl) {
        deletedClIds.add(originalCl.cl_id);
      }
    });


    let distinctDeletedClIdsArray = []
    distinctDeletedClIdsArray = Array.from(deletedClIds);

    console.log(distinctDeletedClIdsArray);
    console.log(added, updated, distinctDeletedClIdsArray);
    if (added.length > 0) {
      await this.insertClassifications(this.diid, added)
    }
    if (distinctDeletedClIdsArray.length > 0) {

      await this.finaldelete(distinctDeletedClIdsArray)
    }
    updated.forEach(async (ele) => {
      await this.updatecl(ele)
    })



  }
  async finaldelete(clidarr: any) {

    let where: any = {
      "and": [
        {
          "cl_id": {
            "in": clidarr
          }
        }
      ]
    };

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      where: where
    };

    try {

      const resp = await this.main.deleteData(req_obj);

      if (!resp.error) {



      } else {

        Swal.fire('Error!', 'Failed to delete classification', 'error');
      }
    } catch (error) {


      Swal.fire('Error!', 'Failed to delete classification', 'error');
    }
  }
  async updatecl(cl: any) {

    let updateobj = {}
    updateobj['cl_cd'] = cl['cl_cd']
    updateobj['cl_val'] = cl['cl_val']
    updateobj['cl_tcd'] = cl['cl_tcd']
    updateobj['cl_tcd_json'] = cl['cl_tcd_json']

    let where: any = {}

    where['cl_id'] = cl['cl_id']

    this.main.updateData({ pf_path: 'dd', pf_name: 'cl', app_cd: 'DD', set: updateobj, where: where }).then(response => {
      if (!response['error']) {
        Swal.fire('Success!', 'Classifications updated successfully.', 'success');
      } else {
        Swal.fire('Error!', 'Failed to update  classifications.', 'error');
      }
    }).catch(error => {

    });


  }




}
